var map = {
	"./arbitrum": 455,
	"./arbitrum.tsx": 455,
	"./aurora": 456,
	"./aurora.tsx": 456,
	"./avax": 457,
	"./avax.tsx": 457,
	"./bsc": 458,
	"./bsc.tsx": 458,
	"./celo": 459,
	"./celo.tsx": 459,
	"./cronos": 460,
	"./cronos.tsx": 460,
	"./emerald": 461,
	"./emerald.tsx": 461,
	"./ethereum": 462,
	"./ethereum.tsx": 462,
	"./fantom": 463,
	"./fantom.tsx": 463,
	"./fuse": 464,
	"./fuse.tsx": 464,
	"./harmony": 465,
	"./harmony.tsx": 465,
	"./heco": 466,
	"./heco.tsx": 466,
	"./kava": 467,
	"./kava.tsx": 467,
	"./metis": 468,
	"./metis.tsx": 468,
	"./moonbeam": 469,
	"./moonbeam.tsx": 469,
	"./moonriver": 470,
	"./moonriver.tsx": 470,
	"./optimism": 471,
	"./optimism.tsx": 471,
	"./polygon": 472,
	"./polygon.tsx": 472
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 691;